import {
  HISTORY_FILTER_VOICEMAIL_COUNT,
  LOGOUT,
  PLAYBACK_MEDIA_URL_SET,
  RESET_STATE,
  STORE_LOGIN,
  UPDATE_NORMAL_VOICEMAIL,
  VOICEMAIL_RESET,
  VOICEMAIL_SET,
} from "../constants/action-types";

const initialState = {
  id: null,
  customer: null,
  self: null,
  remainings: null,
  conversationMedia: null,
  selfState: null,
  playbackMediaURL: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case VOICEMAIL_SET:
      return {
        ...state,
        ...action.voicemail,
      };
    case PLAYBACK_MEDIA_URL_SET:
      return {
        ...state,
        playbackMediaURL: action.playbackMediaURL,
      };
    case UPDATE_NORMAL_VOICEMAIL:
      const connectedTime = new Date(
        action.voicemail.self?.connectedTime || ""
      ).getTime();
      return {
        ...state,
        ...action.voicemail,
        self: {
          ...action.voicemail.self,
          connectedTime,
        },
      };
    case HISTORY_FILTER_VOICEMAIL_COUNT:
      return {
        ...state,
        voicemailCount: action.voicemailCount,
      };
    case LOGOUT:
    case VOICEMAIL_RESET:
      return {
        ...initialState,
      };
    case STORE_LOGIN:
      return {
        ...action.payload.voicemail,
      };
    case RESET_STATE:
      return {};
    default:
      return state;
  }
};
